import citifirst from "./citifirst.png";
import goldlogo from "./goldlogo.png";
import ffi from "./ffi.png";

const IMGS = {
  citifirst: citifirst,
  goldlogo: goldlogo,
  ffi: ffi
};

export default IMGS;